module.exports = __webpack_public_path__ + "static/ceo-b0eb8c66fbd1e37bee472cfd46345c0d.png";